
$(document).on('click', '.bundle_remove', function(){
    $('.cart__form ').addClass('processing');
    // alert('clicked');
    var parentBundleKey = $(this).closest('.cart-item').find('.cart-item__property[bundle="Bundle_key_parent"]').attr('bundlekey');
    var mainitemRemoveBtn = $(this).next();
    // alert(parentBundleKey);
    var itemid = [];
    $('.cart-item__property[bundle="Bundle_key_child"]').each(function(){
        var childBundleKey = $(this).attr('bundlekey');
        var itemKey = $(this).attr('itemkey');
        if(parentBundleKey==childBundleKey){
            itemid.push(itemKey);
           
           
        }
        
    })
    // console.log(itemid);

    var updates = {};

    $.each(itemid, function(index, key) {
        updates[key] = 0;
    });

    $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {
            updates: updates
        },
        success: function(res) {
            // console.log('All items removed', res);
            $(mainitemRemoveBtn)[0].click();
            
        },
        error: function(err) {
            $('.cart__form').removeClass('processing');
            console.log('Error removing items', err);
        }
    });
});


// $(document).on('click', '.cart-form', function(){
//     // alert("clicked");
//    nonMainBundleBundlePrdRemove();
// });

setInterval(() => {
    if($('.sidebar--opened #AjaxCartForm').length>0){
    nonMainBundleBundlePrdRemove();
    }
}, 3000);

function nonMainBundleBundlePrdRemove(){
    var itemWithOutParentBundle = [];

    $('.child_bubdle_prd .cart-item__property[bundle="Bundle_key_child"]').each(function(){
        var childBundleKey = $(this).attr('bundlekey');
        var itemKey = $(this).attr('itemkey')
        var isMatched = false;

        $('.main_bubdle_prd .cart-item__property[bundle="Bundle_key_parent"]').each(function(){
            var ParentBundleKey = $(this).attr('bundlekey');

            if(childBundleKey == ParentBundleKey){
                isMatched = true;
                return false; 
            }
        });

        if(!isMatched){
            itemWithOutParentBundle.push(itemKey);
        }
    });

    // console.log(itemWithOutParentBundle.length);

    var updates = {};

    $.each(itemWithOutParentBundle, function(index, key) {
        updates[key] = 0;
    });

    if(itemWithOutParentBundle.length>0){
        $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: {
                updates: updates
            },
            success: function(res) {
                // console.log('All items removed', res);
                if (typeof window.refreshCart === 'function') {
                window.refreshCart();
                }
                
            },
            error: function(err) {
                $('.cart__form').removeClass('processing');
                console.log('Error removing items', err);
            }
        });
    }
    
}
